import { downgradeComponent } from '@angular/upgrade/static';

import { EnvironmentDetailsComponent } from './environmentDetails';
import { SummaryEnvironmentComponent } from './summary-environment/summary-environment.component';
import { EnvironmentMenuComponent } from './environment-menu/environment-menu.component';
import { EnvironmentActivitiesComponent } from './environment-activities/environment-activities.component';

import { EnvironmentDatabasesComponent } from './environment-databases/environment-databases.component';
import { AutomationComponent } from './automation/automation.component';

import {DeployedPackagesFilterComponent} from "@app/authorized/environmentDetails/deployed-packages/deployed-packages-filter/deployed-packages-filter.component";
import {DeployedPackagesComponent} from "@app/authorized/environmentDetails/deployed-packages/deployed-packages.component";
import {DeployedPackagesDataComponent} from "@app/authorized/environmentDetails/deployed-packages/deployed-packages-data/deployed-packages-data.component";

export default angular.module('environmentDetails', [])
    .component('environmentDetails', EnvironmentDetailsComponent)
    .directive('summaryEnvironment', downgradeComponent({ component: SummaryEnvironmentComponent }))
    .directive('environmentMenu', downgradeComponent({ component: EnvironmentMenuComponent }))
    .directive('environmentActivities', downgradeComponent({ component: EnvironmentActivitiesComponent }))
    .directive('environmentDatabases', downgradeComponent({ component: EnvironmentDatabasesComponent }))
    .directive('automation', downgradeComponent({ component: AutomationComponent }))

    .directive('deployedPackagesFilter', downgradeComponent({ component: DeployedPackagesFilterComponent }))
    .directive('deployedPackages', downgradeComponent({ component: DeployedPackagesComponent }))
    .directive('deployedPackagesData', downgradeComponent({ component: DeployedPackagesDataComponent }))



// WEBPACK FOOTER //
// ./src/app/authorized/environmentDetails/index.js